import { Collection, TextInput, MultilineInput } from "@tblabs/truffle";
import { Human } from "../../../../Models/Human";
import { CustomerExperienceSelector } from "./CustomerExperienceSelector";
import { Entry } from "./Entry";


export class HumanEntryEdit extends Entry<Human>
{
    constructor(human: Human, people: Collection<Human>)
    {
        super(human, people, []);

        this.SetTitle("Człowiek")
            .AddInput("Typ", new TextInput(human.Type))
            .AddInput("Imię i nazwisko", new TextInput(human.Name))
            .AddInput("Telefon", new TextInput(human.Phone))
            .AddInput("Email", new TextInput(human.Email))
            .AddInput("Adres", new TextInput(human.Address))
            .AddInput("Numer konta", new TextInput(human.BankAccountNumber))
            .AddInput("Doświadczenie", new CustomerExperienceSelector(human.Experience))
            .AddInput("Źródło", new TextInput(human.Origin))
            .AddInput("Opis", new MultilineInput(human.Description).Rows(2));
    }
}
